import { render, staticRenderFns } from "./ApproveDenyComponent.vue?vue&type=template&id=de743d36&scoped=true&"
import script from "./ApproveDenyComponent.vue?vue&type=script&lang=ts&"
export * from "./ApproveDenyComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveDenyComponent.vue?vue&type=style&index=0&id=de743d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de743d36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
